<template>
  <div class="view-poi" v-if="poi" role="presentation">
    <header-mobile>
      <template slot="back-button">
        <button class="back-btn secondary-text" @click="goBack">
          &lt;&nbsp;{{ $t("button.back") }}
        </button>
      </template>
      <h3>{{ $tr(poi.name) }}</h3>
    </header-mobile>
    <main class="content-wrapper" aria-label="Main content">
      <div class="media-preview" role="presentation">
        <poi-media-slider v-if="poi" :transcript='transcript' :mediaList='poi.content'/>
      </div>
      <ul class="tabs" role="tablist" aria-label="POI content">
        <li role="tab">
          <router-link :to="{name: 'PoiInformation'}" tag="a">{{ $t("poiView.description") }}</router-link>
        </li>
        <li role="tab">
          <router-link :to="{name: 'PoiDirections'}" tag="a">{{ $t("poiView.directions") }}</router-link>
        </li>
        <li role="tab">
          <router-link :to="{name: 'PoiNotes'}" tag="a">{{ $t("poiView.notes") }}</router-link>
        </li>
      </ul>
      <poi-navbar :navBarPoi="navBarPoi" @next="nextPoi()" @prev="prevPoi()" class="mobile-visible"></poi-navbar>
      <progress-bar v-if="currentTour.type"></progress-bar>
      <div class="content-box" role="presentation">
        <div class="content" role="presentation" aria-label="Content">
          <router-view/>
        </div>
      </div>
      <poi-navbar :navBarPoi="navBarPoi" @next="nextPoi()" @prev="prevPoi()" class="desktop-visible"></poi-navbar>
    </main>
  </div>
</template>

<script>
import HeaderMobile from '@/components/HeaderMobile'
import ProgressBar from '@/views/ProgressBar'
import PoiMediaSlider from '@/components/PoiMediaSlider'
import PoiNavbar from '@/views/poi/PoiNavbar'

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'PoiView',
  components: {
    'header-mobile': HeaderMobile,
    'poi-media-slider': PoiMediaSlider,
    'progress-bar': ProgressBar,
    'poi-navbar': PoiNavbar
  },
  created () {
    this.update()
  },
  watch: {
    $route (to, from) {
      this.update()
    }
  },
  methods: {
    ...mapMutations('poi', ['clearCurrentTour', 'clearUnfinishedTour']),
    ...mapMutations('history', ['popEntry']),
    update: function () {
      this.getPOIById(this.$route.params.id)

      // Tracking visits only during a tour
      if (this.currentTour.type) {
        this.trackPOIVisit(this.$route.params.id)
      }

      if (this.unfinishedTour && !this.unfinishedTour.lastVisitedPoi) {
        this.trackPoiUnfinishedTour(this.$route.params.id)
      }
    },
    nextPoi: function () {
      if (this.navBarPoi.next) {
        this.trackPoiUnfinishedTour(this.navBarPoi.next.id)
        this.$router.push({ name: this.$route.name, params: { id: this.navBarPoi.next.id } })
        document.querySelector('.page-container').focus()
      }
    },
    prevPoi: function () {
      if (this.navBarPoi.prev) {
        this.trackPoiUnfinishedTour(this.navBarPoi.prev.id)
        this.$router.push({ name: this.$route.name, params: { id: this.navBarPoi.prev.id } })
        document.querySelector('.page-container').focus()
      }
    },
    goBack: function () {
      this.clearCurrentTour()
      this.popEntry()

      const whereTo = this.lastEntry

      if (whereTo) {
        this.popEntry()

        this.$router.push({ name: whereTo.name, params: whereTo.params, query: whereTo.query })
      } else {
        this.$router.push({ name: 'ExploreCampus' })
      }
    },
    ...mapActions('poi', ['getPOIById', 'trackPoiUnfinishedTour']),
    ...mapActions('student', ['trackPOIVisit'])
  },
  computed: {
    navBarPoi: function () {
      return this.getSiblingsPois(this.poi.id)
    },
    ...mapState('poi', {
      poi: state => state.currentPoi,
      currentTour: state => state.currentTour,
      unfinishedTour: state => state.unfinishedTour
    }),
    ...mapGetters('poi', ['getSiblingsPois']),
    ...mapGetters('history', ['lastEntry']),
    transcript: function () {
      if (this.poi.transcript.en || this.poi.transcript.es) {
        return this.poi.transcript
      }
    }
  }
}
</script>
